import * as React from "react";
import type { SVGProps } from "react";
const SvgMountainsGlacier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#mountains-glacier_svg__a)">
      <path
        fill="currentColor"
        d="M21 21h-7a1 1 0 0 1-1-.74l-.23-.87a3.26 3.26 0 0 1 .53-2.8 1.32 1.32 0 0 0 .15-1.39l-.1-.2h-2.86a3.24 3.24 0 0 1-.49 2.73 1.32 1.32 0 0 0-.22 1.09l.24.94a1 1 0 0 1-.554 1.153A1 1 0 0 1 9 21H3a1 1 0 0 1-.93-1.37L6.69 8a2.38 2.38 0 0 1 2-1.54A2.18 2.18 0 0 1 10.2 7l1.22-2.54A2.43 2.43 0 0 1 13.55 3a2.36 2.36 0 0 1 2.1 1.5l6.26 15.1a1 1 0 0 1-.09.94A1 1 0 0 1 21 21m-6.23-2h4.73L13.82 5.3c-.1-.22-.22-.3-.3-.3-.1 0-.21.11-.29.28l-2 4.07a1 1 0 0 1-.88.56 1 1 0 0 1-.9-.52l-.38-.68c-.08-.15-.2-.25-.27-.24s-.21.09-.31.31L4.47 19h3.26a3.32 3.32 0 0 1 .62-2.47 1.27 1.27 0 0 0 .12-1.35l-.36-.73a1 1 0 0 1 0-1A1 1 0 0 1 9 13h5a1 1 0 0 1 .89.55l.38.75a3.3 3.3 0 0 1-.27 3.42 1.34 1.34 0 0 0-.25 1.15z"
      />
    </g>
    <defs>
      <clipPath id="mountains-glacier_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMountainsGlacier;
